import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { initializeAuth, getCurrentUser } from '../services/authService';
import { getUserPermissions } from '../features/access-management/services/accessManagementService';
import { setPermissions, setPermissionsLoading } from '../app/store/slices/authSlice';

// ✅ Define public routes that should NOT trigger API calls
const PUBLIC_ROUTES = [
  '/',
  '/home',
  '/login',
  '/register',
  '/forgot-password',
  '/privacy-policy',
  '/terms-of-service',
];

/**
 * Component to handle auth initialization based on current route
 * Only makes API calls when NOT on public pages
 */
const AuthInitializer = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const initializeAuthData = async () => {
      const currentPath = location.pathname;
      
      // ✅ Check if current route is a public route
      const isPublicRoute = PUBLIC_ROUTES.includes(currentPath);
      
      if (!isPublicRoute) {
        // ✅ Only initialize auth (which makes API calls) on protected routes
        await initializeAuth();
        
        // ✅ Also fetch user permissions
        const user = getCurrentUser();
        if (user) {
          try {
            dispatch(setPermissionsLoading(true));
            const response = await getUserPermissions(user.id || user.email);
            const perms = response?.payload || response?.permissions || {};
            dispatch(setPermissions(perms));
          } catch (error) {
            console.error('❌ Error loading user permissions:', error);
            dispatch(setPermissions({}));
          } finally {
            dispatch(setPermissionsLoading(false));
          }
        }
      }
    };

    initializeAuthData();
  }, [location.pathname, dispatch]);

  return null; // This component doesn't render anything
};

export default AuthInitializer;
